import { useState, useEffect } from 'react';
import formatCurrency from '@utils/formatCurrency';

const useFormattedCurrency = (amount: number | null) => {
  const [formattedCurrency, setFormattedCurrency] = useState<string>('');

  useEffect(() => {
    setFormattedCurrency(formatCurrency(amount));
  }, [amount]);

  return formattedCurrency;
};

export default useFormattedCurrency;
